import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';

export const StyledLoginPageWrapper = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.text.main};
  background-color: ${({ theme }) => theme.colors.background.dark};
  padding: 1.6rem 1.2rem;
  min-height: calc(100vh - 90px);

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 8rem 0;
  }
`;

export const StyledLoginPageCard = styled.div`
  background-color: ${({ theme }) => theme.colors.background.main};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  border-radius: ${({ theme }) => theme.radius.small};
  max-width: 49.2rem;
  margin: 0 auto;
  padding: 3.2rem 1.8rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    padding: 4.6rem;
  }
`;

export const StyledLoginHeader = styled.h1`
  font-size: 2.4rem;

  line-height: 3.7rem;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.main};

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  }
`;

export const StyledLoginSubtitle = styled.p`
  margin-top: 0.9rem;
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledForm = styled.form<{ $isError: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 4.6rem;
  margin-top: ${({ $isError }) => ($isError ? '3rem' : '4.6rem')};
  transition: margin-top 300ms ease-in-out;
`;

export const StyledFooterWrapper = styled.div`
  width: 100%;
  text-align: center;
`;

const errorBoxVisibleStyles = css`
  height: 0;
  opacity: 0;
  margin: 0;
  padding: 0 1.6rem;
  overflow: hidden;
`;

const errorBoxHiddenStyles = css`
  height: 7.4rem;
  margin: 3rem 0;
  opacity: 1;
  padding: 1.6rem;
`;

export const StyledErrorBox = styled.div`
  border-radius: ${({ theme }) => theme.radius.small};
  border-color: ${({ theme }) => theme.colors.error.main};
  background-color: ${({ theme }) => theme.colors.error.lighter};
  border-width: 0.1rem;
  border-style: solid;
  display: flex;
  flex-direction: row;
  gap: 1.4rem;
  align-items: flex-start;
  margin: 3rem 0;
  padding: 1.6rem;
  > p {
    line-height: 2rem;
  }

  &.error-box-enter {
    ${errorBoxVisibleStyles}
  }

  &.error-box-enter-active {
    ${errorBoxHiddenStyles}
    transition: height 300ms ease-in-out, padding 300ms ease-in-out, opacity 300ms ease-in-out, margin 300ms ease-in-out;
  }

  &.error-box-enter-done {
    ${errorBoxHiddenStyles}
  }

  &.error-box-exit {
    ${errorBoxHiddenStyles}
    transition: height 300ms ease-in-out, padding 300ms ease-in-out, opacity 300ms ease-in-out, margin 300ms ease-in-out;
  }

  &.error-box-exit-active {
    ${errorBoxVisibleStyles}
  }

  &.error-box-exit-done {
    ${errorBoxVisibleStyles}
  }
`;

export const StyledErrorIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  color: ${({ theme }) => theme.colors.error.main};
  margin-top: 0.2rem;
`;
